import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import FilterBuilder from './FilterBuilder'

/**
 * Blade 3 of the Groupings & Filters dialog. Hosts the FilterBuilder for
 * the currently-focused grouping. The grouping name itself doesn't have
 * any non-filter settings today (the "Include benchmarks" switch lives at
 * the dialog level), so the entire body is the FilterBuilder.
 *
 * When no grouping is focused, renders an empty-state placeholder.
 */
export default function GroupingDetailPanel ({ grouping, filter, onChange, classes }) {
  const handleFilterChange = useCallback((nextTree) => {
    onChange(grouping, nextTree)
  }, [grouping, onChange])

  if (!grouping) {
    return (
      <div className={classes.detailPanel}>
        <div className={classes.detailEmpty}>
          Select a grouping in the middle column to configure filters.
        </div>
      </div>
    )
  }

  return (
    <div className={classes.detailPanel}>
      <div className={classes.detailTitle}>{grouping}</div>
      <div className={classes.detailSubtitle}>
        Scope filters apply at this grouping level and affect rollups to higher levels.
      </div>
      <FilterBuilder
        tree={filter}
        onChange={handleFilterChange}
        classes={classes}
      />
    </div>
  )
}

GroupingDetailPanel.propTypes = {
  grouping: PropTypes.string,
  filter: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}
